'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// import { PropTypes } from 'prop-types';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loadingIndicatorFadeDelay = (0, _styledComponents.keyframes)(['from{transform:rotate(0deg);transform-origin:center center;}to{transform:rotate(360deg);transform-origin:center center;}']);

var LoadingIndicatorPrimitive = _styledComponents2.default.svg.withConfig({
  displayName: 'LoadingIndicator__LoadingIndicatorPrimitive',
  componentId: 'sc-13lcl7f-0'
})(['height:', ';width:', ';pointer-events:none;animation:', ' 0.9s infinite;& path{stroke:', ';fill:', ';stroke-width:0px;transition:opacity 0.15s 0.3s;opacity:1;}'], function (props) {
  return props.size || '16px';
}, function (props) {
  return props.size || '16px';
}, loadingIndicatorFadeDelay, function (props) {
  return props.color;
}, function (props) {
  return props.color;
});

var LoadingIndicator = function LoadingIndicator(props) {
  return _react2.default.createElement(
    LoadingIndicatorPrimitive,
    _extends({}, props, { viewBox: '0 0 16 16' }),
    _react2.default.createElement('path', { d: 'M15.9966648,8.23173827 C15.9988832,8.15475057 16,8.07749938 16,8 C16,3.6 12.4,0 8,0 C3.6,0 0,3.6 0,8 C0,12.4 3.6,16 8,16 C9.11320868,16 10.1752094,15.769564 11.140657,15.3540371 L10.3274381,13.5275176 C9.61085353,13.8316026 8.82413759,14 8,14 C4.7,14 2,11.3 2,8 C2,4.7 4.7,2 8,2 C11.3,2 14,4.7 14,8 C14,8.07237493 13.9987013,8.14446126 13.996126,8.21623684 L15.9966648,8.23173827 Z'
    })
  );
};

exports.default = LoadingIndicator;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-dev/thread/lib/components/LoadingIndicator/index.js
// module id = 537
// module chunks = 29